import Enlish from "./en-US.json";
import Bangali from "./bn-BD.json";

export default {
  "en-US": Enlish,
  "bn-BD": Bangali,
};
